export const locale = {
    lang: 'en',
    data: {
        'SYSTEM_MESSAGES': {
           'WRONG_LOGIN_OR_PWD': 'Wrong login or password!',
           'WRONG_EMAIL_OR_PIN': 'Wrong email or pin!',
           'NEW_ASSIGNED_EVENT': 'New assigned event',
           'NEW_EMAIL': 'New email',
           'NEW_DOC_ADDED': 'New document added',
           'NEW_PAYMENT_METHOD': 'New payment method added',
           'NEW_UPCOMING_EVENT': 'New upcoming event',
           'NEW_TICKET': 'New ticket',
           'NEW_ASSIGNED_TICKET': 'New assigned ticket',
           'CLIENT': 'Client',
           'LEAD': 'Lead',
           'DOC_TYPE': 'Document type',
           'PAYMENT_METHOD': 'Payment method',
           'EVENT_TYPE': 'Event type',
           'TICKET_SUBJECT': 'Subject',
           'NEW_TICKET_MESSAGE': 'New ticket message',
           'MESSAGE': 'Message'
        }
    }
};



// WEBPACK FOOTER //
// ./src/app/services/i18n/en.ts